import React from 'react'
import {IIncomeDocument} from '../IncomeDocumentDetailPage'
import {Button, Col, Row} from 'react-bootstrap'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'
import {numberFormat} from '../../../utils/Functions'
import {Link} from 'react-router-dom'
import {
  groupPaymentsForDisplay,
  sumPaymentGroupAmount,
  sumPaymentGroupWhTaxPrice,
} from '../../../utils/paymentGrouping'

interface ITabDocumentCredit {
  document: IIncomeDocument
  creditDocuments: IIncomeDocument[]
}

const TabDocumentCredit: React.FC<ITabDocumentCredit> = (props) => {
  const { document, creditDocuments } = props

  if (!document) return <></>

  const fullPaymentAmount = document.totalAmount
  const totalCreditAmount = creditDocuments.reduce((a, b) => a + b.totalAmount, 0)
  const newAmount = fullPaymentAmount - totalCreditAmount

  return (
    <KTCard>
      <KTCardBody className={'py-3 px-4'}>
        <Row className={'fs-6'}>
          <Col xs={12}>
            <h4>{'ข้อมูลการชำระ'}</h4>
          </Col>
          <Col xs={6}>
            <div className={'d-flex justify-content-between'}>
              <strong>{'มูลค่าเต็มใบแจ้งหนี้ :'}</strong>
              <span>{`${numberFormat(fullPaymentAmount)} บาท`}</span>
            </div>
            <div className={'d-flex justify-content-between'}>
              <strong>{`มูลค่าใบลดหนี้จำนวน ${creditDocuments.length} รายการ :`}</strong>
              <span>{`${numberFormat(totalCreditAmount)} บาท`}</span>
            </div>
            <div className={'d-flex justify-content-between'}>
              <strong>{'มูลค่าที่ถูกต้องของใบแจ้งหนี้'}</strong>
              <span style={{color: '#43bf76'}}>{`${numberFormat(newAmount)} บาท`}</span>
            </div>
          </Col>
        </Row>
        <hr />
        <Row className={'fs-6'}>
          {creditDocuments.map((item, index) => {
            return (
              <Col xs={12} key={`credit-doc-${index}`}>
                <Row>
                  <Col xs={6} className={'border-end'}>
                    <strong className={'fs-4'}>
                      {`ใบลดหนี้ใบที่ ${index + 1} # `}
                      <Link to={`/revenue-credit-note/${item.id}/detail`} target={'_blank'}>
                        {item.code}
                      </Link>
                    </strong>
                    <div className={'d-flex justify-content-between'}>
                      <strong>{'วันที่เอกสาร :'}</strong>
                      <span className={'ms-1'}>{item.date}</span>
                    </div>
                    <div className={'d-flex justify-content-between'}>
                      <strong>{'มูลค่าใบลดหนี้ :'}</strong>
                      <span className={'ms-1'}>{`${numberFormat(item.totalAmount)} บาท`}</span>
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div>
                      <strong>{'ประเภทการคืนสินค้า :'}</strong>
                      <span className={'ms-1'}>{item.date}</span>
                    </div>
                    <div>
                      <strong>{'สาเหตุการลดหนี้ :'}</strong>
                      <span className={'ms-1'}>{item.incomeDocumentDebt?.shortDescription}</span>
                    </div>
                  </Col>
                  {groupPaymentsForDisplay(item.incomeDocumentPayments).map(({payment: paymentItem, children}, number) => {
                    return (
                      <Col xs={12} className={'mt-2'} key={`credit-doc-payment-${number}`}>
                        <h4 style={{color: '#6c6df2'}} className={'mb-0'}>{`ชำระเงินครั้งที่ ${
                          number + 1
                        }`}</h4>
                        {children.length > 0 && <div>{`ช่องทางชำระเพิ่มเติม ${children.length} รายการ`}</div>}
                        <div>
                          <strong>{'มูลค่าที่ชำระรวม :'}</strong>
                          <div
                            className={'py-2 px-3 text-end'}
                            style={{width: 300, background: '#ececff', color: '#6c6df2'}}
                          >
                            <strong className={'fs-4'}>
                              {numberFormat(
                                sumPaymentGroupAmount(paymentItem, children) +
                                  sumPaymentGroupWhTaxPrice(paymentItem, children)
                              )}
                            </strong>
                            <span className={'ms-2'}>{'บาท'}</span>
                          </div>
                        </div>
                      </Col>
                    )
                  })}
                </Row>
                <hr />
              </Col>
            )
          })}
        </Row>
      </KTCardBody>
    </KTCard>
  )
}

export default TabDocumentCredit
